<div class="container">

  <tgrid-page-header></tgrid-page-header>

  <div class="help-section">
    <div class="section-header">
      <vulcan-icon size="42px" icon="question" weight="fill"></vulcan-icon>
      <h2>Help</h2>
    </div>

    <div class="section-subtitle">
      Welcome to our Help Page! Here, you'll find a collection of valuable resources designed to support your experience
      with TASTI-GRID. In addition to helpful tutorials and FAQs, we provide direct links to our Release Notes,
      which outline the latest updates and enhancements. Use these resources to stay informed and make the most of
      TASTI-GRID!
    </div>

    <div class="section-content">
      <div class="content-info">

        <div class="info-card-container">

          <div class="info-card">
            <vulcan-icon size="32px" icon="folder"></vulcan-icon>
            <span>Quick Start</span>
            <p>This resource is designed to help you get up and running with our web application quickly and
              effortlessly. It includes step-by-step instructions, essential tips, and highlights of key features to
              ensure you have a smooth onboarding experience. Whether you're a first-time user or looking to maximize
              your productivity, this guide will empower you to navigate the application with confidence.</p>

            <a mat-flat-button download="TASTIGRID_QuickStart.pdf"
               href="/dist/angulario/browser/src/assets/reference/TASTIGRID_QuickStart.pdf">
              <button mat-flat-button color="primary">
                Download PDF
              </button>
            </a>
          </div>

          <div class="info-card">
            <vulcan-icon size="32px" icon="folder"></vulcan-icon>
            <span>Release notes</span>
            <p>A summary of the latest updates, improvements, and fixes made to our web application. These notes
              highlight new features, enhancements, and bug resolutions, keeping you informed about changes that can
              enhance your experience and usage of the application. Be sure to check back regularly to stay
              up-to-date!</p>
            <button mat-flat-button color="primary" routerLink="/app/help/release-notes">
              View Notes
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>

<tgrid-page-footer></tgrid-page-footer>
</div>
